import { Box, Stack, Typography } from '@mui/material';

import { ExportConnectionEnum, FileTypeEnum } from '@verantos-dev/data-access-export-connections';
import {
  ApiWorkflowDialog,
  Dropdown,
  RadioButton,
  TextField,
} from '@verantos-dev/shared-components';
import { theme } from '@verantos-dev/shared-styles';

import { ExportCohortModalSubmitted } from './ExportCohortModalSubmitted';
import { useExportCohortModal } from '../../hooks/useExportCohortModal';
import { useExportCohortModalStrings } from '../../hooks/useExportCohortModalStrings';

export const ExportCohortModal = () => {
  const { contentMessages, dialogMessages } = useExportCohortModalStrings();
  const {
    onClose,
    onSubmit,
    isSubmitting,
    exportCohortError,
    isInitialLoading,
    isValidForSubmit,

    projectName,
    cohortName,
    exportLocationOptions,
    exportLocationId,
    onChangeExportLocationId,
    selectedExportLocation,

    schemaName,
    onChangeSchemaName,
    fileName,
    onChangeFileName,
    fileType,
    onChangeFileType,
  } = useExportCohortModal();

  return (
    <ApiWorkflowDialog
      id="exportCohortModal"
      title={contentMessages.title}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={isSubmitting}
      dialogMessages={dialogMessages}
      submittingError={exportCohortError}
      isInitialLoading={isInitialLoading}
      isValidForSubmit={isValidForSubmit}
      renderSubmitted={
        <ExportCohortModalSubmitted
          projectName={projectName}
          cohortName={cohortName}
          schemaName={schemaName}
          fileName={fileName}
          fileType={fileType}
          selectedExportLocation={selectedExportLocation}
        />
      }
    >
      <Stack direction={'column'} gap={6}>
        <Typography variant="body1">{contentMessages.description}</Typography>
        <Box paddingLeft={3} paddingBlock={1} display={'flex'} flexDirection={'column'} gap={1}>
          <Typography variant="body2" fontSize={'12px'} color={theme.palette.text.secondary}>
            {contentMessages.projectName}
          </Typography>
          <Typography
            variant="body1"
            fontSize={'16px'}
            lineHeight={'24px'}
            color={theme.palette.text.primary}
          >
            {projectName}
          </Typography>
        </Box>
        <Box paddingLeft={3} paddingBlock={1} display={'flex'} flexDirection={'column'} gap={1}>
          <Typography variant="body2" fontSize={'12px'} color={theme.palette.text.secondary}>
            {contentMessages.cohortName}
          </Typography>
          <Typography
            variant="body1"
            fontSize={'16px'}
            lineHeight={'24px'}
            color={theme.palette.text.primary}
          >
            {cohortName}
          </Typography>
        </Box>
        <Dropdown
          id={'export-connection-location-export-connection'}
          label={contentMessages.exportLocation}
          placeholder={contentMessages.exportLocationPlaceholder}
          width={'auto'}
          options={exportLocationOptions}
          onChange={onChangeExportLocationId}
          value={exportLocationId}
        />
        {selectedExportLocation?.connectionType === ExportConnectionEnum.SNOWFLAKE && (
          <TextField
            id={'snowflake-schema-name-export-connection'}
            displayLabel={contentMessages.schemaName}
            helperText={contentMessages.schemaNameHelptext}
            placeholder={contentMessages.schemaNamePlaceholder}
            value={schemaName}
            onChange={onChangeSchemaName}
            width={552}
          />
        )}
        {selectedExportLocation?.connectionType === ExportConnectionEnum.S3 && (
          <>
            <TextField
              id={'s3-file-name-export-connection'}
              displayLabel={contentMessages.fileName}
              helperText={contentMessages.fileNameHelptext}
              placeholder={contentMessages.fileNamePlacholder}
              value={fileName}
              onChange={onChangeFileName}
              width={552}
            />
            <Box paddingLeft={3} display={'flex'} flexDirection={'column'} gap={1}>
              <Typography variant="body2" fontSize={'12px'} color={theme.palette.text.secondary}>
                {contentMessages.fileType}
              </Typography>
              <RadioButton
                id={'s3-csv-type-export-connection'}
                label={contentMessages.fileTypeCsv}
                checked={fileType === FileTypeEnum.CSV}
                onChange={() => onChangeFileType(FileTypeEnum.CSV)}
              />
              <RadioButton
                id={'parquet-file-type-export-connection'}
                label={contentMessages.fileTypeParquet}
                checked={fileType === FileTypeEnum.PARQUET}
                onChange={() => onChangeFileType(FileTypeEnum.PARQUET)}
              />
            </Box>
          </>
        )}
      </Stack>
    </ApiWorkflowDialog>
  );
};
